<script lang="ts">
import { defineComponent } from 'vue';
import LinkedButton from '../components/ui-elements/LinkedButton.vue';
import SearchSlotsForm from '../components/basic/SearchSlotsForm.vue';
import PatientSearch from '../components/basic/PatientSearch.vue';
import {mapGetters} from 'vuex';
import ScheduledCards from '@/components/modules/ScheduledCards.vue';
import SlotDetails from '@/components/modules/SlotDetails.vue';

export default defineComponent({
  name: 'SearchSlots',
  components: {ScheduledCards, LinkedButton, SearchSlotsForm, PatientSearch, SlotDetails},
  data() {
    return {
      isSearching: false,
      selectedPatient: null as any,
      slotSelectionTrigger: 0,
    };
  },
  created() {
    // Function to handle first open
  },
  computed: {
    ...mapGetters(['isSlotsLoaded', 'selectedSlot']),
  },
  methods: {
    onPatientSelected(patient: any) {
      this.selectedPatient = patient;
      this.$store.commit('setSelectedPatient', patient);
      // Reset slots when patient changes
      this.$store.commit('resetSlots');
      this.$store.commit('clearSelectedSlot');
    },
    onPatientCleared() {
      this.selectedPatient = null;
      this.$store.commit('setSelectedPatient', null);
      // Reset slots when patient is cleared
      this.$store.commit('resetSlots');
      this.$store.commit('clearSelectedSlot');
    },
    onSlotSelected() {
      this.slotSelectionTrigger++;
    },
  },
});
</script>

<template>
  <div class="container--fluid">
    <div class="containerWidth my-5 px-2">
      <div class="flex justify-between align-center mb-4">
        <h1 class="title">Appointment Finder</h1>
        <div class="flex justify-end">
          <LinkedButton link="/" text="Go to Dashboard" mdi-icon="mdi-view-dashboard" type="primary" :icon-size="18" :font-size="13" />
          <v-btn
              class="ml-3 my-1"
              color="#d94554"
              @click="$store.dispatch('authLogout')"
              icon
              size="small"
              variant="flat"
          >
            <v-icon color="white" :size="18">mdi-logout</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="threeColumnLayout">
        <div class="patientColumn">
          <PatientSearch @patient-selected="onPatientSelected" @patient-cleared="onPatientCleared" />
        </div>

        <div class="searchColumn">
          <SearchSlotsForm @is-loading="isSearching = !isSearching" />
        </div>

        <div class="resultsColumn resultsContainer">
          <div v-if="isSearching" class="preloaderContainer">
            <v-progress-circular
                class="spinner"
                indeterminate
                :size="100"
                :width="4"
                color="primary" />
            <p class="text-center mt-3">Searching for slots</p>
          </div>

          <ScheduledCards v-if="!isSearching && isSlotsLoaded && !selectedSlot" @slot-selected="onSlotSelected" />
          <SlotDetails v-if="!isSearching && selectedSlot" :trigger="slotSelectionTrigger" />

          <div v-if="!isSearching && !isSlotsLoaded && !selectedSlot" class="emptyState">
            <v-icon size="80" color="#ccc">mdi-calendar-search</v-icon>
            <p class="emptyStateText">Search results will appear here</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
.containerWidth {
  max-width: 1600px;
  margin: 0 auto;
}

.title {
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #000000;
}

.threeColumnLayout {
  display: grid;
  grid-template-columns: 420px 1fr 600px;
  gap: 16px;
  align-items: start;
}

.preloaderContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.preloaderContainer p {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px dashed #ccc;
  min-height: 300px;
}

.emptyStateText {
  margin-top: 16px;
  font-size: 14px;
  color: #999;
}

.resultsContainer {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px 20px;
  border: 1px solid #e0e0e0;
}

@media (max-width: 1400px) {
  .threeColumnLayout {
    grid-template-columns: 380px 380px 1fr;
  }
}

@media (max-width: 1200px) {
  .threeColumnLayout {
    grid-template-columns: 360px 360px 1fr;
  }
}

@media (max-width: 1024px) {
  .threeColumnLayout {
    grid-template-columns: 1fr;
  }
}
</style>
